<div class="businessinfo_page">
    <div class="questionary_main_container">
        <div class="questionary_data_content" *ngIf="!noData" style="text-align: center;">
            <div class="create_business_info" routerLink="/Dashboard/Questionary">Create Business Info</div>
        </div>
        <div class="questionary_data_content" *ngIf="noData">

            <!-- Loop through the BusinessInfos array -->
            <div *ngFor="let list_of_business of BusinessInfos; let i = index" style="border-radius: 0px; border: 1px solid #ccc; margin-top: 15px;">
                <div class="title_name">
                    <div  class="business_name">Business Information : {{ list_of_business.BusinessInfo_BusinessName }}</div>
                    <div class="business_buttons">
                        <button (click)="onEdit(i)">
                            <mat-icon>edit</mat-icon>
                        </button>
                    </div>
                </div>

                <div class="business_info_details">
                    <div class="questionary_header">Business Information</div>
                    <div class="questionary_header_details">
                        <div class="questionary_row">
                            <div class="questionary_side_headers">Business Name</div>
                            <div class="questionary_value">{{list_of_business.BusinessInfo_BusinessName}}</div>
                        </div>
                        <div class="questionary_row">
                            <div class="questionary_side_headers">Business Category</div>
                            <div class="questionary_value">{{list_of_business.BusinessInfo_BusinessCategory}}</div>
                        </div>
                        <div class="questionary_row">
                            <div class="questionary_side_headers">Business Codes</div>
                            <div class="questionary_value">{{list_of_business.BusinessInfo_BusinessCode}}</div>
                        </div>
                        <div class="questionary_row">
                            <div class="questionary_side_headers">Business Type</div>
                            <div class="questionary_value">{{list_of_business.BusinessInfo_BusinessType}}</div>
                        </div>
                        <div class="questionary_row">
                            <div class="questionary_side_headers">Website URL</div>
                            <div class="questionary_value">{{list_of_business.BusinessInfo_WebsiteURL}}</div>
                        </div>
                    </div>

                    <div class="questionary_header">Current Online Presence</div>
                    <div class="questionary_header_details">
                        <div class="questionary_row">
                            <div class="questionary_side_headers">Do you currently sell online ?</div>
                            <div class="questionary_value">{{list_of_business.CurrentOnlinePresence_DoYouCurrentlySellOnline}}</div>
                        </div>
                        <div class="questionary_row">
                            <div class="questionary_side_headers">Current number of Instagram followers</div>
                            <div class="questionary_value">{{list_of_business.CurrentOnlinePresence_InstagramFollowers}}</div>
                        </div>
                        <div class="questionary_row">
                            <div class="questionary_side_headers">Instagram Username</div>
                            <div class="questionary_value">{{list_of_business.CurrentOnlinePresence_InstagramUsername}}</div>
                        </div>
                        <div class="questionary_row">
                            <div class="questionary_side_headers">LinkedIn Username</div>
                            <div class="questionary_value">{{list_of_business.CurrentOnlinePresence_LinkedInUsername}}</div>
                        </div>
                    </div>

                    <div class="questionary_header">Content Requirements</div>
                    <div class="questionary_header_details">
                        <div class="questionary_row">
                            <div class="questionary_side_headers">What type of content are you interested in ?</div>
                            <div class="questionary_value">{{list_of_business.ContentRequirements_IntrestedContent}}</div>
                        </div>
                        <div class="questionary_row">
                            <div class="questionary_side_headers">Do you have specific themes or styles in mind ?</div>
                            <div class="questionary_value">{{list_of_business.ContentRequirements_SpecificThemes}}</div>
                        </div>
                        <div class="questionary_row">
                            <div class="questionary_side_headers">Description</div>
                            <div class="questionary_value">{{list_of_business.ContentRequirements_Description}}</div>
                        </div>
                        <div class="questionary_row">
                            <div class="questionary_side_headers">Sample Image</div>
                            <div *ngIf="Content_Requirements_Sample_Images.length > 0">
                                <div *ngFor="let image of Content_Requirements_Sample_Images" style="display: inline-block; margin: 10px;">
                                    <img [src]="image" alt="Selected Photo" style="max-width: auto; height: 172px;">
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="questionary_header">Target Audience</div>
                    <div class="questionary_header_details">
                        <div class="questionary_row">
                            <div class="questionary_side_headers">Who is your target audience ?</div>
                        </div>
                        <div class="questionary_row">
                            <div class="questionary_side_headers">AGE</div>
                            <div class="questionary_value">From : {{list_of_business.TargetAudience_FromAge}}</div>
                            <div class="questionary_value">To : {{list_of_business.TargetAudience_ToAge}}</div>
                        </div>
                        <div class="questionary_row">
                            <div class="questionary_side_headers">GENDER</div>
                            <div class="questionary_value">{{list_of_business.TargetAudience_Gender}}</div>
                        </div>
                        <div class="questionary_row">
                            <div class="questionary_side_headers">INTERESTS</div>
                            <div class="questionary_value">{{list_of_business.TargetAudience_Interests}}</div>
                        </div>
                        <div class="questionary_row">
                            <div class="questionary_side_headers">Any specific geographic location you are targeting ?</div>
                            <div class="questionary_value">{{list_of_business.TargetAudience_SpecificLocations}}</div>
                        </div>
                    </div>

                    <div class="questionary_header">Content Goals</div>
                    <div class="questionary_header_details">
                        <div class="questionary_row">
                            <div class="questionary_side_headers">What are your primary goals for this content ?</div>
                            <div class="questionary_value">{{list_of_business.ContentGoals_PrimaryGoals}}</div>
                        </div>
                        <div class="questionary_row">
                            <div class="questionary_side_headers">Are there any key messages or brand values you want to communicate?</div>
                            <div class="questionary_value">{{list_of_business.ContentGoals_KeyMessages}}</div>
                        </div>
                    </div>

                    <div class="questionary_header">Regular Posting Schedule</div>
                    <div class="questionary_header_details">
                        <div class="questionary_row">
                            <div class="questionary_side_headers">Monday to Friday: Posts</div>
                            <div class="questionary_side_headers">Saturday: Reels</div>
                            <div class="questionary_side_headers">Sunday: Carousel</div>
                        </div>
                        <div class="questionary_row">
                            <div class="questionary_side_headers">Do you want to customize this schedule ?</div>
                            <div class="questionary_value">{{list_of_business.RegularPostingSchedule_Customize}}</div>
                        </div>
                        <div class="questionary_row">
                            <div class="questionary_side_headers">Monday</div>
                            <div class="questionary_value">{{list_of_business.RegularPostingSchedule_Mon}}</div>
                        </div>
                        <div class="questionary_row">
                            <div class="questionary_side_headers">Tuesday</div>
                            <div class="questionary_value">{{list_of_business.RegularPostingSchedule_Tue}}</div>
                        </div>
                        <div class="questionary_row">
                            <div class="questionary_side_headers">Wednesday</div>
                            <div class="questionary_value">{{list_of_business.RegularPostingSchedule_Wed}}</div>
                        </div>
                        <div class="questionary_row">
                            <div class="questionary_side_headers">Thursday</div>
                            <div class="questionary_value">{{list_of_business.RegularPostingSchedule_Thu}}</div>
                        </div>
                        <div class="questionary_row">
                            <div class="questionary_side_headers">Friday</div>
                            <div class="questionary_value">{{list_of_business.RegularPostingSchedule_Fri}}</div>
                        </div>
                        <div class="questionary_row">
                            <div class="questionary_side_headers">Saturday</div>
                            <div class="questionary_value">{{list_of_business.RegularPostingSchedule_Sat}}</div>
                        </div>
                        <div class="questionary_row">
                            <div class="questionary_side_headers">Sunday</div>
                            <div class="questionary_value">{{list_of_business.RegularPostingSchedule_Sun}}</div>
                        </div>
                    </div>

                    <div class="questionary_header">Business Specific Uploads</div>
                    <div class="questionary_header_details">
                        <div class="questionary_row">
                            <div class="questionary_side_headers">If Cafe: Please upload your menu.</div>
                            <div *ngIf="Business_Specific_Uploads_Images.length > 0" style="height: 200px; overflow-x: hidden;">
                                <div *ngFor="let image of Business_Specific_Uploads_Images" style="display: inline-block; margin: 10px;">
                                    <img [src]="image" alt="Selected Photo" style="width: auto; height: 172px;">
                                </div>
                            </div>
                        </div>
                        <div class="questionary_row">
                            <div class="questionary_side_headers">For Other Businesses: Please upload a list of your services.</div>
                            <div class="questionary_value">{{list_of_business.BusinessSpecificUploads_Services}}</div>
                        </div>
                    </div>

                    <div class="questionary_header">Competitor Information</div>
                    <div class="questionary_header_details">
                        <div class="questionary_row">
                            <div class="questionary_side_headers">List any competitors you want to differentiate from or benchmark against.</div>
                            <div class="questionary_value">{{list_of_business.CompetitorInformation_Details}}</div>
                        </div>
                    </div>

                    <div class="questionary_header">Additional Details</div>
                    <div class="questionary_header_details">
                        <div class="questionary_row">
                            <div class="questionary_side_headers">Any additional information you think we should know?</div>
                            <div class="questionary_value">{{list_of_business.AdditionalDetails_Details}}</div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
</div>
